import React from 'react';
import { 
  Box, 
  Typography, 
  Avatar, 
  Button 
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import AddIcon from '@mui/icons-material/Add';

const EmptyActivityCard = ({ 
  onAddActivity, 
  title = "No Recent Activities", 
  description = "No activities recorded yet. Start engaging with this lead to see activity history here.",
  buttonText = "Add Activity",
  showButton = true,
  compact = false 
}) => {
  return (
    <Box sx={{ 
      p: compact ? 2.5 : 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 120 : 200
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'rgba(156, 39, 176, 0.1)', 
          color: '#9C27B0', 
          width: compact ? 40 : 56, 
          height: compact ? 40 : 56,
          margin: '0 auto',
          mb: compact ? 1.5 : 2,
          boxShadow: '0 4px 12px rgba(156, 39, 176, 0.2)'
        }}
      >
        <HistoryIcon sx={{ fontSize: compact ? 20 : 28 }} />
      </Avatar>
      
      <Typography 
        variant={compact ? "subtitle1" : "h6"} 
        color="text.primary" 
        sx={{ 
          fontWeight: 600, 
          mb: compact ? 0.5 : 1,
          fontSize: compact ? '0.875rem' : '1.125rem'
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ 
          lineHeight: 1.6, 
          mb: compact ? 1.5 : 2,
          fontSize: compact ? '0.813rem' : '0.875rem',
          maxWidth: 300
        }}
      >
        {description}
      </Typography>
      
      {showButton && onAddActivity && (
        <Button 
          startIcon={<AddIcon sx={{ fontSize: compact ? '0.875rem' : '1rem' }} />}
          variant="contained"
          size="small"
          onClick={onAddActivity}
          sx={{ 
            textTransform: 'none',
            fontSize: compact ? '0.813rem' : '0.875rem',
            fontWeight: 500,
            bgcolor: '#9C27B0',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(156, 39, 176, 0.2)',
            '&:hover': {
              bgcolor: '#7B1FA2',
              boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
            }
          }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyActivityCard; 